<vc-spinner *ngIf="dvmPlan == null"></vc-spinner>

<div
   *ngIf="dvmPlan != null"
   class="outer-container">
   <div class="grid-container">
      <vc-rounded-card
         [cardTitle]="dvmPlan.dvmName"
         class="namesCard"
         titleSize="large"
         style="flex: 0.7; position: relative">
         <button
            class="v-button v-button-md v-green scheduleButton"
            (click)="openMeetingSchedulerModal(); $event.preventDefault()">
            <i class="fa fa-calendar-days"></i>
            &nbsp; BOOK APPOINTMENT WITH DVM
         </button>

         <div class="name-container">
            <mat-grid-list
               cols="2"
               rowHeight="65px"
               gutterSize="8px">
               <mat-grid-tile [colspan]="1">
                  <div class="item-group">
                     <div class="item-heading">DVM</div>
                     <div class="item-value">{{ dvmPlan.dvmName }}</div>
                  </div>
               </mat-grid-tile>

               <mat-grid-tile
                  [colspan]="1"
                  class="item-div">
                  <div class="item-group">
                     <div class="item-heading">Regional Manager</div>
                     <div class="item-value">{{ dvmPlan.rmName }}</div>
                  </div>
               </mat-grid-tile>
            </mat-grid-list>

            <mat-grid-list
               cols="2"
               rowHeight="65px"
               gutterSize="8px">
               <mat-grid-tile [colspan]="1">
                  <div class="item-group">
                     <div class="item-heading">Hospital</div>
                     <div class="item-value">{{ dvmPlan.practiceName }}</div>
                  </div>
               </mat-grid-tile>

               <mat-grid-tile [colspan]="1">
                  <div class="item-group">
                     <div class="item-heading">Chief of Staff Assistant</div>
                     <div class="item-value">{{ dvmPlan.cosaName }}</div>
                  </div>
               </mat-grid-tile>
            </mat-grid-list>
         </div>
      </vc-rounded-card>

      <vc-rounded-card
         colorClass="v-blue"
         class="versionsCard"
         style="flex: 0.3">
         <div
            *ngIf="dvmPlan != null"
            class="date-container">
            <div class="vc-header">
               <h3 class="vc-title">
                  <i
                     class="vc-icon"
                     aria-hidden="true"></i>
                  Save & Revisions
               </h3>
               <div class="vc-meta">
                  <div *ngIf="dvmPlan.dateUpdated">
                     <div class="meta-heading light-text">Last Saved</div>
                     <div class="meta-value light-text">{{ getLastSavedDatetime() }}</div>
                  </div>
               </div>
            </div>

            <hr />

            <div class="mt-4">
               <label class="vc-label">{{ dvmPlan.dateUpdated ? "Saved versions" : "You have no saved versions" }}</label>
               <vc-single-select-dropdown
                  [disabled]="!dvmPlan.dateUpdated"
                  optionLabel="name"
                  variantClass=""
                  sizeClass="v-dropdown-full"
                  [showClear]="false"
                  [filter]="true"
                  [filterBy]="'name'"
                  [items]="historicalVersions"
                  [setValue]="formVersion"
                  (selectionChange)="handleVersionChanged($event)"></vc-single-select-dropdown>
            </div>

            <div class="mt-3">
               <button
                  mat-button
                  (click)="onClickSave()"
                  class="w-100 v-button v-button-lg v-teal">
                  Save Changes
               </button>
            </div>
         </div>
      </vc-rounded-card>
   </div>

   <div class="grid-container">
      <vc-rounded-card style="flex: 0.6">
         <div class="item-group">
            <!--<vc-radio-group
               [(ngModel)]="selectedCommunicationPreference"
               direction="row"
               [required]="true"
               label="Communication Preference"
               [options]="[
                  { label: 'Email', value: '0' },
                  { label: 'Text', value: '1' },
                  { label: 'Phone Call', value: '2' }
               ]"></vc-radio-group>-->
            <div class="vc-field">
               <label class="vc-label">
                  Communication Preference
                  <span class="required-asterisk">*</span>
               </label>

               <div class="d-flex flex-row vc-inline">
                  <vc-checkbox
                     inputId="comm-email"
                     label="Email"
                     [required]="true"
                     [ngModel]="selectedCommunicationPreferences.includes('0')"
                     (ngModelChange)="onCommunicationCheckboxChange('0', $event)"></vc-checkbox>

                  <vc-checkbox
                     inputId="comm-text"
                     label="Text"
                     [required]="true"
                     [ngModel]="selectedCommunicationPreferences.includes('1')"
                     (ngModelChange)="onCommunicationCheckboxChange('1', $event)"></vc-checkbox>

                  <vc-checkbox
                     inputId="comm-phone"
                     label="Phone Call"
                     [required]="true"
                     [ngModel]="selectedCommunicationPreferences.includes('2')"
                     (ngModelChange)="onCommunicationCheckboxChange('2', $event)"></vc-checkbox>
               </div>
            </div>
         </div>

         <div class="row-container">
            <div
               class="item-group"
               style="flex: 0.7">
               <vc-text-input
                  label="Email"
                  type="email"
                  [required]="true"
                  [(ngModel)]="emailInputValue"
                  placeholder="Enter email"
                  [maxlength]="255"></vc-text-input>
            </div>

            <div
               class="item-group"
               style="flex: 0.3">
               <vc-text-input
                  label="Phone Number"
                  type="text"
                  [required]="true"
                  [(ngModel)]="phoneNumberInputValue"
                  placeholder="111-222-3333"
                  [maxlength]="50"></vc-text-input>
            </div>
         </div>

         <div class="row-container">
            <div
               class="item-group"
               style="flex: 0.7">
               <vc-single-select-dropdown
                  [items]="educationOptions"
                  placeholder="Make A Selection"
                  optionLabel="name"
                  label="Vet School"
                  [required]="true"
                  [filter]="true"
                  [filterBy]="'name'"
                  variantClass=""
                  sizeClass="v-dropdown-full"
                  [setValue]="selectedUniversity"
                  (selectionChange)="handleUniversityChanged($event)"></vc-single-select-dropdown>
            </div>

            <div
               class="item-group"
               style="flex: 0.3">
               <vc-text-input
                  label="Grad Year"
                  type="number"
                  [required]="true"
                  [(ngModel)]="gradYearInputValue"
                  placeholder="e.g. 2025"
                  [maxlength]="4"></vc-text-input>
            </div>
         </div>

         <vc-radio-group
            [(ngModel)]="selectedLeaderAspirations"
            direction="row"
            [required]="true"
            label="Aspirations to be a Leader"
            [options]="[
               { label: 'Yes', value: true },
               { label: 'No', value: false }
            ]"></vc-radio-group>

         <vc-radio-group
            [(ngModel)]="selectedDeNovoCandidate"
            direction="row"
            [required]="true"
            label="Viable candidate and interested in launching a de novo"
            [options]="[
               { label: 'Yes', value: true },
               { label: 'No', value: false }
            ]"></vc-radio-group>
      </vc-rounded-card>

      <vc-rounded-card style="flex: 0.5">
         <div class="medical-group">
            <vc-dvm-medical-interests
               [title]="'Medical Interests'"
               [idPrefix]="'chk-interest'"
               [interests]="medicalInterestOptions"
               [selectedInterests]="medicalInterests"
               [otherSelectedInterests]="medicalExpertise"
               (selectionChanged)="handleMedicalInterestsChanged($event)"></vc-dvm-medical-interests>
         </div>
      </vc-rounded-card>

      <vc-rounded-card style="flex: 0.5">
         <div class="medical-group">
            <vc-dvm-medical-interests
               [title]="'Medical Expertise'"
               [idPrefix]="'chk-expertise'"
               [interests]="medicalInterestOptions"
               [selectedInterests]="medicalExpertise"
               [otherSelectedInterests]="medicalInterests"
               (selectionChanged)="handleMedicalExpertiseChanged($event)"></vc-dvm-medical-interests>
         </div>
      </vc-rounded-card>
   </div>

   <div class="grid-container">
      <vc-rounded-card style="flex: 0.6">
         <div class="item-group">
            <vc-radio-group
               [(ngModel)]="selectedYearsExperience"
               direction="row"
               [required]="true"
               label="Years Experience"
               [options]="[
                  { label: '0-2', value: '0' },
                  { label: '3-5', value: '1' },
                  { label: '6-10', value: '2' },
                  { label: '10+', value: '3' }
               ]"></vc-radio-group>
         </div>
      </vc-rounded-card>

      <vc-rounded-card style="flex: 0.4">
         <div class="item-group">
            <vc-radio-group
               [(ngModel)]="selectedLendAHand"
               direction="row"
               [required]="true"
               label="Interested in Lend-A-Hand Program"
               [options]="[
                  { label: 'Yes', value: true },
                  { label: 'No', value: false }
               ]"></vc-radio-group>
         </div>
      </vc-rounded-card>
   </div>

   <div class="grid-container">
      <vc-rounded-card style="flex: 1">
         <vc-dvm-feedback-row
            [rowData]="keyNeedsAndInterestsRowData"
            maxLength="500"
            class="w-100"></vc-dvm-feedback-row>
      </vc-rounded-card>
   </div>
   <div class="grid-container">
      <vc-rounded-card style="flex: 1">
         <vc-dvm-feedback-row
            [rowData]="challengesAndConcernsRowData"
            maxLength="500"
            class="w-100"></vc-dvm-feedback-row>
      </vc-rounded-card>
   </div>

   <div class="grid-container">
      <vc-rounded-card style="flex: 1">
         <vc-dvm-feedback-row
            [rowData]="aspirationsAndGoalsRowData"
            maxLength="500"
            class="w-100"></vc-dvm-feedback-row>
      </vc-rounded-card>
   </div>
   <div class="grid-container">
      <vc-rounded-card style="flex: 1">
         <vc-dvm-feedback-row
            [rowData]="engagementPlanRowData"
            maxLength="500"
            class="w-100"></vc-dvm-feedback-row>
      </vc-rounded-card>
   </div>

   <div class="grid-container">
      <vc-rounded-card style="flex: 1">
         <vc-dvm-feedback-row
            [rowData]="recognitionAndAppreciationRowData"
            maxLength="500"
            class="w-100"></vc-dvm-feedback-row>
      </vc-rounded-card>
   </div>
</div>
